import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AccountsContextService } from '../../accounts/account-context.service';
import { AccountsService } from '../../accounts/accounts.service';
import { WhiteLabelService } from '../white-label.service';

export const forNonWhiteLabelOrRedirectToWizardOtherwise: CanActivateFn = () => {
  const whiteLabelService = inject(WhiteLabelService);
  const router = inject(Router);
  const accountService = inject(AccountsService);
  const ctxService = inject(AccountsContextService);

  return whiteLabelService.isWhiteLabel
    ? accountService.advertisers$
      .pipe(
        map(
          advertisers => router.createUrlTree([
            advertisers.length
              ? ctxService.getAccountDashboardRoute(advertisers[0])
              : ctxService.ACCOUNTS_WIZARD_URL
          ]),
        ),
      )
    : true;
};

export const forNonWhiteLabelOrForNewlyInvited: CanActivateFn = () => {
  const whiteLabelService = inject(WhiteLabelService);
  const accountService = inject(AccountsService);

  return whiteLabelService.isWhiteLabel
    ? accountService.advertisers$
      .pipe(
        map(advertisers => !advertisers.length),
      )
    : true;
};
